/**
 * Whether the map's closures came from the platform, and if not, why.
 *
 * Read by the map's CLOSURES pane, so an empty list never reads as "nothing
 * is closed" when the truth is "the register could not be read". Kept in a
 * module that imports nothing, for the reason `report.ts` gives.
 */

export interface ClosuresFeedState {
  /** closures installed from the register on the last read */
  fed: number;
  /** the register refused this person (a 403): only their own entries show */
  refused?: string;
  /** the last read failed for another reason; what it said before still shows */
  failed?: string;
}

let state: ClosuresFeedState | null = null;
const listeners = new Set<() => void>();

/** null until the platform has fed the map, and always under the demonstration. */
export const closuresFeed = (): ClosuresFeedState | null => state;

export function setClosuresFeed(next: ClosuresFeedState | null): void {
  state = next;
  for (const fn of listeners) fn();
}

/** Shaped for `useSyncExternalStore`. */
export function subscribeClosuresFeed(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
